import { Component, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { UserInitial } from '@elan/core/shared/user-initial/user-initial';
import { EncryptedStorageService } from '@elan/services/encrypted-storage.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-header',

  standalone: true,
  imports: [UserInitial, CommonModule],
  templateUrl: './header.html'
})
export class Header {
  @Output() toggleSidebar = new EventEmitter<void>();  

  username: string | null = '';
  dropdownOpen = false;

  constructor(
    private encryptedStorage: EncryptedStorageService,
    private router: Router
  ) { }

  ngOnInit(): void {
    const loginDetail = this.encryptedStorage.getItem<any>('token');
    this.username = loginDetail?.data?.user?.name ?? null;
  }

  //header button to request sidebar toggle
  onSidebarButtonClick(): void {
    this.toggleSidebar.emit();
  }
  /**
   * Toggle user account dropdown
   */
  toggleDropdown(): void {
    this.dropdownOpen = !this.dropdownOpen;
  }

  /**
   * Close dropdown when clicking outside
   */
  closeDropdown(): void {
    this.dropdownOpen = false;
  }

  /**
   * Handle user logout with confirmation
   */
  userLogout(): void {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to log out!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, log out!",
      buttonsStyling: false,
      customClass: {
        confirmButton: 'btn btn-primary popup-btn-color px-4',
        cancelButton: 'btn btn-secondary popup-btn-color ms-2 px-4',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.encryptedStorage.removeItem('token');
        this.closeDropdown();
        setTimeout(() => {
          this.router.navigate(['/login']);
        }, 100);
      }
    });
  }
}

